var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9 19.65 7.85 18.6 12 14.45l4.15 4.15-1.05 1.05-3.1-3.1ZM12 9.55 7.85 5.4 8.9 4.35l3.1 3.1 3.1-3.1 1.05 1.05Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLess);
export default __webpack_public_path__ + "static/media/icon-less.d45e9dca71ddc38fccc3aed9f333d656.svg";
export { ForwardRef as ReactComponent };